<template>
    <v-row class="mx-12 mb-6">
        <v-col class="" cols="12">
            <v-card class="green lighten-4 pa-6 mx-auto elevation-12">
                <v-card-title class="justify-center">
                    <v-layout align-center>
                        <v-flex>
                            <div class="teal--text display-2 font-weight-bold text-center">왜 장기렌트를 선택해야 할까요?</div>
                            <div class="teal--text headline font-weight-bold text-center">구매, 리스보다 훨씬 경제적인 선택!</div>
                        </v-flex>
                    </v-layout>
                </v-card-title>
                <v-row>
                    <v-col v-for="(card, index) in cards" lg="4" md="12">
                        <v-card class="elevation-6">
                            <div class="d-flex">
                                <div>
                                    <v-avatar class="ma-3" size="125" tile>
                                        <v-img :src="card.src"></v-img>
                                    </v-avatar>
                                </div>
                                <div>
                                    <v-card-title class="headline"><b class="teal--text">{{index+1}}.</b>{{card.title}}</v-card-title>
                                    <v-card-subtitle><span v-for="(item, itemIndex) in card.subtitleItems">{{item}}<v-icon v-if="itemIndex !== card.subtitleItems.length-1">mdi-forward</v-icon></span></v-card-subtitle>
                                </div>
                            </div>
                        </v-card>
                    </v-col>
                </v-row>
                <v-layout justify-center>
                    <v-flex>
                        <v-card class="elevation-6 mt-3">
                            <v-simple-table>
                                <template v-slot:default>
                                    <thead>
                                        <tr>
                                            <th class="text-left teal--text" width="185px">구분</th>
                                            <th class="text-left teal--text">직구매</th>
                                            <th class="text-left teal--text">리스</th>
                                            <th class="text-left teal--text">VIP 리모렌터카 장기렌트</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>보험료 및 범위</td>
                                            <td>본인(개인보험적용)</td>
                                            <td>본인부담(본인/리스사 선택)</td>
                                            <td>렌터카 회사 부담이며, 누구나 운전가능</td>
                                        </tr>
                                        <tr>
                                            <td>사고, 수리시 차량 대차</td>
                                            <td>불가능</td>
                                            <td>가해 사고 시 3일만 무료대차, 약정기간에 따른 렌터카 서비스(2년3일/3년5일한)</td>
                                            <td>사고 즉시 무료대차</td>
                                        </tr>
                                        <tr>
                                            <td>사고처리업무</td>
                                            <td>본인 직접</td>
                                            <td>고객이 직접 처리</td>
                                            <td>렌터카 회사(사고처리반 운영)전담 처리</td>
                                        </tr>
                                        <tr>
                                            <td>LPG 사용</td>
                                            <td>–</td>
                                            <td>불가</td>
                                            <td>누구나 사용 가능하며 유류비 절감 가능</td>
                                        </tr>
                                        <tr>
                                            <td>소유(명의)</td>
                                            <td>본인 소유</td>
                                            <td>법적 소유권은 리스회사(본인 소유도 가능)</td>
                                            <td>VIP 리모렌터카 회사 소유</td>
                                        </tr>
                                        <tr>
                                            <td>회계처리 및 각종 제세금</td>
                                            <td>본인 부담</td>
                                            <td>리스료 전액 비용처리/본인 부담</td>
                                            <td>대여료 전액 비용처리/렌터카 회사 부담</td>
                                        </tr>
                                        <tr>
                                            <td>계약시 담보 및 채권확보(신용심사)</td>
                                            <td>차종에 따라 1~2명의 보증인 필요(무보증 할부 이용가능)</td>
                                            <td>보증인, 담보, 근저당설정 제출서류가 까다로움(대표자 및 인 보증 필요)</td>
                                            <td>일반 기업체 보증보험 및 보증금 예치(필요시 대표이사 인 보증)</td>
                                        </tr>
                                        <tr>
                                            <td>차량 정비 및 수리(차량유지비/일반관리비)</td>
                                            <td>본인 부담</td>
                                            <td>고객이 직접 정비입고(정비직원이 임의운행시 보험처리 불가함, 일정기간이 지나면 본인 부담, 직영 정비업소 아님)</td>
                                            <td>순회방문 점검 및 일상의 모든 정비 업무를 당사가 책임지고 처리함(월 대여료에 수리, 정비비, 검사비 포함)</td>
                                        </tr>
                                        <tr>
                                            <td>마일리지 제한</td>
                                            <td>무한정</td>
                                            <td>약정거리 초과시 리스료 추가부담(계약시 운행거리 사전 약정해야 함)</td>
                                            <td>운행거리 제한 없음(무한정)</td>
                                        </tr>
                                        <tr>
                                            <td>사고시 보험료 할증</td>
                                            <td>있음</td>
                                            <td>사고시 보험료 할증(리스료증가)</td>
                                            <td>사고할증은 렌터카 회사 부담이며 고객 대여료 변동은 없음</td>
                                        </tr>
                                    </tbody>
                                </template>
                            </v-simple-table>
                        </v-card>
                    </v-flex>
                </v-layout>
            </v-card>
        </v-col>
    </v-row>
</template>
<script>
export default {
  name: "NewcarWhyUs",
  components: {
  },
  data: () => ({
      cards: [
          {
              title: '비용절감',
              subtitleItems: ['초기비용', '세금감면(취득세/등록세/보험료 無)', '유류비 절감(LPG차량 이용)', '인건비 절감(법인)'],
              src: require('../../assets/newcar/icon7.png')
          },
          {
              title: '차량유지/관리용이',
              subtitleItems: ['최상 상태의 차량 유지', '사고처리 대행(02 - 3141 - 2345)', '무료 대차 서비스'],
              src: require('../../assets/newcar/icon8.png')
          },
          {
              title: '재무회계처리 용이',
              subtitleItems: ['건실한 재무 관리', '투명한 비용운영(세금계산서 처리)', '자금운용 계획 수립 용이'],
              src: require('../../assets/newcar/icon9.png')
          },
      ]
  })
};
</script>
<style scoped></style>
